/**
 * @module History
 * @description History object used in front end routing.
 */

import createHistory from 'history/createBrowserHistory';

export default createHistory();



// WEBPACK FOOTER //
// ./src/history.js